import { render, staticRenderFns } from "./addServiceBilling.vue?vue&type=template&id=c3b0da36"
import script from "./addServiceBilling.vue?vue&type=script&lang=js"
export * from "./addServiceBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports